import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { Modal as EPModal, Box, Button, Copy, QR as QRCode, Input, Flex } from '@elparking/components'
import { copyToClipboard } from '@elparking/utils'
import { FormattedMessage, injectIntl } from 'react-intl'
import UrlTo from 'commons/js/util/UrlTo'
const ERROR = -1
const SUCCESS = 1
const ShareModal = ({ unbornId, urlBase, uuid, onClose, copyToClipboard, intl }) => {
    const [copy, setCopy] = useState(null)

    const onCopy = useCallback((copy) => {
        setCopy(null)
        if (copy) {
            copyToClipboard(copy).then(() => {
                setCopy(SUCCESS)
                /* istanbul ignore next */
                setTimeout(() => {
                    setCopy(null)
                }, 2000)
            }).catch((e) => setCopy(ERROR))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [copyToClipboard, intl, setCopy])

    const url = urlBase + UrlTo.get('rental-car/un-born-share', { unbornId, uuid })

    return <EPModal isShown onClose={onClose} width='812px' height={['100%', 'auto']} label=' ' showCloseButton showModalTitle={false}>
        <Box mt={['0px', '3em']} flexDirection='column'>
            <Box textAlign='center' mt={['1em', '1em', '0']}>
                <QRCode value={url} size={160}/>
            </Box>
            <Copy size={['large', 'xxLarge']} fontWeight='medium' textAlign='center' color='accent_dark' padding='1em 0em'>
                <FormattedMessage defaultMessage='Comparte los datos de la reserva' />
            </Copy>
            <Copy fontSize='small' textAlign='center' fontColor='darkGray' padding='1em'>
                <FormattedMessage defaultMessage='Copia y comparte este enlace para que otro usuario pueda relizar la reserva' />
            </Copy>
            <Flex width='100%' padding='1em' backgroundColor='lightGray30' borderRadius='10px' alignItems='center' flexDirection={['column', 'column', 'row']} >
                <Box w='100%' padding='5px 0'>
                    <Input backgroundColor='lightGray30' width='100%' value={url} disable showClearButton={false} />
                </Box>
                <Box w='200px' padding={['0 0 1em 0', '0 0 1em 0', '0 0 0 5px']}>
                    <Button width='100%' onClick={() => onCopy(url)} fontWeight='book' dataTest='accept-button-simple-modal'>
                        <FormattedMessage defaultMessage='Copiar'/>
                    </Button>
                </Box>
            </Flex>
            <Box height='40px' width='100%'>
                {(copy === SUCCESS) && <Copy transform='uppercase' fontSize='xxSmall' textAlign='right' fontColor='main'>
                    <FormattedMessage defaultMessage='Copiado' />
                </Copy>}
                {(copy === ERROR) && <Copy transform='uppercase' fontSize='xxSmall' textAlign='right' fontColor='error'>
                    <FormattedMessage defaultMessage='No tiene permisos para copiar al portapapeles' />
                </Copy>}
            </Box>
        </Box>
    </EPModal>
}

ShareModal.propTypes = {
    unbornId: PropTypes.any,
    uuid: PropTypes.any,
    copyToClipboard: PropTypes.func,
    onClose: PropTypes.func,
    urlBase: PropTypes.string,
    intl: PropTypes.object,
}

ShareModal.defaultProps = {
    copyToClipboard,
    urlBase: document.location.protocol + '//' + document.location.hostname,
}

export default injectIntl(ShareModal)
